@if (!isLoading) {
  <section @fadeIn>
    <button type="button" class="mt-20 mr-20 button is-primary md:mt-30" (click)="activateRetireUpSso()"
      *showIfOne="'RetireUp:Access|RetireUpFree:Access'">
      <span>
        Log Into RetireUp Pro
      </span>
    </button>
  </section>
}